import React, { useState, useEffect } from "react";

import Link from "@mui/material/Link";

import { useNavigate, useLocation } from "react-router-dom";

import { useTranslation } from 'react-i18next';

import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import MDInput from "../components/MDInput";
import MDButton from "../components/MDButton";

import OthelloCheckBox from "../componentsothello/OthelloCheckBox.jsx";
import OthelloVersionWeb from "../componentsothello/OthelloVersionWeb.jsx";

import { CircularProgress } from "@mui/material";

export default function RegisterPage({ ...props }) {
    // const { classes, t } = this.props;
    const { t } = useTranslation();

    const navigate = useNavigate();

    const [submitted, setsubmitted] = useState(false);
    const [error, seterror] = useState(0);
    const [modoapps, setmodoapps] = useState(window.location.pathname.indexOf("/authapps") !== -1)
    const [checked, setchecked] = useState([]);

    const [loading, setLoading] = useState(false);

    const handleToggle = (value) => {

        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setchecked(newChecked);
    }

    const handleClick = (event) => {
        event.preventDefault();

        if (checked != null && checked.length > 0 && checked[0] == 1) {
            //window.location.assign('/admin/dashboard');

            //const data = new FormData(event.target);
            let formulario = document.getElementById('formregister');
            var data = new FormData(formulario);

            setLoading(true);

            fetch('api/Data/GrabarUsuarioApp', {
                method: 'POST',
                body: data,

            }).then(response => response.json()).then(res => {
                //Si hubo error
                if (!res) {
                    setsubmitted(true);
                    seterror(1);
                    setLoading(false);
                }
                else {
                    if (window.location.href.includes("reservas.ovtspain.es"))
                        window.location.assign('/authapps/loginreservas');
                    else
                        window.location.assign('/authapps/loginapp');
                    //navigate('/authapps/loginapp');
                    //window.location.assign('/admin/dashboard');
                }
            }).catch(error => {
                setsubmitted(true);
                seterror(2);
            });
        }
        else
            seterror(3);
    }

    const handleCancekClick = () => {
        window.location.assign('/auth/auth');
    }

    return (
        <form id="formregister">
            <MDBox mb={2}>
                <MDInput id="nombre" name="nombre" type="text" label="Nombre" fullWidth error={submitted && error == 1 ? true : false} />
            </MDBox>
            <MDBox mb={2}>
                <MDInput id="apellidos" name="apellidos" type="text" label="Apellidos" fullWidth error={submitted && error == 1 ? true : false} />
            </MDBox>
            <MDBox mb={2}>
                <MDInput id="email" name="email" type="text" label="Email" fullWidth error={submitted && error == 1 ? true : false} />
            </MDBox>
            <MDBox mb={2}>
                <MDInput id="pass" name="pass" type="password" label="Password" fullWidth error={submitted && error == 1 ? true : false} />
            </MDBox>
            <MDBox mb={2}>
                <MDInput id="pass2" name="pass2" type="password" label="Confirmar Password" fullWidth error={submitted && error == 1 ? true : false} />
            </MDBox>
            <OthelloCheckBox label="Acepto las condiciones y politica de privacidad" checked={checked[0] == 1} onChange={() => handleToggle(1)} />            
            {loading ? <MDBox mt={2} mb={1} justifyContent={'center'}><center> <CircularProgress /></center> </MDBox> : ""}
            <MDBox mt={4} mb={1}>
                <MDButton variant="gradient" color="info" size="large" onClick={(e) => handleClick(e)} fullWidth>
                    Crear Cuenta
                </MDButton>
            </MDBox>
            {error == 1 ? <div><br /> <p style={{ color: '#eb4034' }}>Los datos introducidos no son v&aacute;lidos</p> </div> : ""}
            {error == 3 ? <div><br /> <p style={{ color: '#eb4034' }}>Debe aceptar la condiciones y politica de privacidad</p> </div> : ""}
            <MDBox mt={1} textAlign="center">
                        <MDTypography variant="button" color="text">
                            Alguna duda, contacte con nosotros?{" "}
                            <Link href={"https:atmovilidad.com/"} target="_blank">
                                <MDTypography
                                    variant="button"
                                    color="info"
                                    fontWeight="medium"
                                    textGradient>
                                    Accede a nuestra web
                                </MDTypography>
                            </Link>
                        </MDTypography>
                    </MDBox>
                    <MDBox py={3} px={3} textAlign="center" fontSize={12} >
                        <OthelloVersionWeb />
                    </MDBox>
        </form >
    );
}
